export default __webpack_public_path__ + "static/media/refund_gray.45889c5c.svg";